module.exports = __webpack_public_path__ + "img/logo-rdp.358d2a53.svg";